module.exports = __webpack_public_path__ + "static/media/chodba-prizemi.2d7b6e74.jpg";